<script setup lang="ts">
// PROPS
interface Props {
    to?: string;
}
defineProps<Props>();

// COMPOSABLES
const { tt } = useTypedI18n();
</script>

<template>
    <section class="bg-primary-50 flex flex-col gap-7 rounded-xl border border-neutral-300 p-4 md:flex-row md:p-6">
        <div
            class="aspect-[9/5] self-stretch rounded-xl bg-[url('/trust-report/vehicle-inspection.webp')] bg-cover bg-center bg-no-repeat md:w-60"
            role="img"
            aria-hidden
        />

        <div class="text-primary-800 flex flex-1 flex-col gap-5 font-medium">
            <h4 class="text-xl">
                <BaseI18nT keypath="mktg.trustReport.title.bold" tag="strong" class="font-semibold">
                    <template #highlight>
                        <span class="text-primary">{{ tt('mktg.trustReport.title.highlight') }}</span>
                    </template>
                </BaseI18nT>

                {{ tt('mktg.trustReport.title.base') }}
            </h4>

            <p>
                {{ tt('mktg.trustReport.description1') }} <br />
                {{ tt('mktg.trustReport.description2') }}
            </p>
            <p>{{ tt('mktg.trustReport.conclusion') }}</p>

            <div class="mt-6">
                <UButton v-if="to" size="xl" :label="tt('mktg.trustReport.cta')" :to="to" />
            </div>
        </div>
    </section>
</template>
